import React, { useState } from 'react';
import './Menu.css';
import OpenHours from '../components/OpenHours';
import OrderNowButton from '../components/OrderNowButton';
import LunchMenuPages from '../components/LunchMenuPages';
import breakfastMenu from '../assets/menus/Breakfast.jpg';
import breakfastContMenu from '../assets/menus/Breakfast (Con\'t).png';
import dinnerMenu from '../assets/menus/dinner-sept-2026.jpg';
import drinksMenu from '../assets/menus/drinks-sept-2026.jpg';

const LUNCH_MENU_PDF = `${process.env.PUBLIC_URL}/menus/lunch-2026.pdf`;

const Menu = () => {
  const [activeTab, setActiveTab] = useState('breakfast');

  const menuTabs = [
    { id: 'breakfast', label: 'Breakfast', image: breakfastMenu },
    { id: 'breakfast-cont', label: 'Breakfast Continued', image: breakfastContMenu },
    { id: 'lunch', label: 'Lunch', pdfSrc: LUNCH_MENU_PDF },
    { id: 'dinner', label: 'Dinner', image: dinnerMenu },
    { id: 'drinks', label: 'Drinks', image: drinksMenu },
  ];

  return (
    <div className="menu-page">
      <div className="menu-container">
        <OpenHours />
        
        <h1 className="menu-title">Our Menu</h1>
        <div className="order-now-wrapper">
          <OrderNowButton theme="dark" />
        </div>
        
        <div className="menu-tabs">
          {menuTabs.map((tab) => (
            <button
              key={tab.id}
              className={`menu-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="menu-content">
          {menuTabs.map((tab) => (
            <div
              key={tab.id}
              className={`menu-panel ${activeTab === tab.id ? 'active' : ''}`}
            >
              {tab.pdfSrc ? (
                <LunchMenuPages fileUrl={tab.pdfSrc} />
              ) : (
                <img
                  src={tab.image}
                  alt={`${tab.label} Menu`}
                  className="menu-image"
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu; 